import React from 'react';
import PropTypes from 'prop-types';

import { getFormRedirectUrl } from '../../Utils/FormUtils';

import { StyledWrapper, StyledForm, StyledH4, StyledInput, StyledHiddenLabel, StyledSocialLoginWrapper, StyledFormSwitcher } from './AccountFormStyles';

var _ref2 = React.createElement(
  StyledH4,
  null,
  'Login'
);

var _ref3 = React.createElement('input', { type: 'hidden', name: 'form_type', defaultValue: 'customer_login' });

var _ref4 = React.createElement('input', { type: 'hidden', name: 'utf8', defaultValue: '\u2713' });

var _ref5 = React.createElement(
  StyledHiddenLabel,
  { htmlFor: 'CustomerEmail' },
  'Email'
);

var _ref6 = React.createElement(StyledInput, {
  required: '',
  type: 'email',
  name: 'customer[email]',
  id: 'CustomerEmail',
  placeholder: 'Email'
});

var _ref7 = React.createElement(
  StyledHiddenLabel,
  { htmlFor: 'CustomerPassword' },
  'Password'
);

var _ref8 = React.createElement(StyledInput, {
  required: '',
  type: 'password',
  defaultValue: '',
  name: 'customer[password]',
  id: 'CustomerPassword',
  placeholder: 'Password'
});

var _ref9 = React.createElement('input', {
  type: 'submit',
  defaultValue: 'Sign In',
  className: 'btn btn--full no-borders gradient-shimmer'
});

var _ref10 = React.createElement(
  StyledSocialLoginWrapper,
  null,
  React.createElement('div', { className: 'one-click-social-login' })
);

var LoginForm = function LoginForm(_ref) {
  var toggleAccountForm = _ref.toggleAccountForm,
      isModal = _ref.isModal;

  var redirectUrl = getFormRedirectUrl();

  return React.createElement(
    StyledWrapper,
    { isModal: isModal },
    _ref2,
    React.createElement(
      StyledForm,
      {
        method: 'post',
        action: '/account/login',
        id: 'customer_login',
        acceptCharset: 'UTF-8',
        noValidate: 'novalidate'
      },
      _ref3,
      _ref4,
      React.createElement('input', { type: 'hidden', name: 'checkout_url', value: redirectUrl }),
      _ref5,
      _ref6,
      _ref7,
      _ref8,
      _ref9
    ),
    _ref10,
    React.createElement(
      StyledFormSwitcher,
      {
        onClick: function onClick() {
          return toggleAccountForm({ formType: 'REGISTER' });
        }
      },
      'Create Account'
    ),
    React.createElement(
      StyledFormSwitcher,
      {
        small: true,
        onClick: function onClick() {
          return toggleAccountForm({ formType: 'RECOVER' });
        }
      },
      'Forgot your password?'
    )
  );
};

LoginForm.propTypes = {
  toggleAccountForm: PropTypes.func.isRequired,
  isModal: PropTypes.bool
};

export default LoginForm;